module.exports = __webpack_public_path__ + "img/left-arrow.6468634d.svg";